import * as types from '../mutation-types'
import { ajaxFun, initVuex } from '../actions'

// fav:收藏,mine:动态发布数量等
const state = {
  fav: {},
  mine: {},
  favFlag: false,
  favTime: '',
  mineFlag: false,
  mineTime: ''
}

// getters
const getters = {
  getMyContentListInfo: state => state.fav,
  getMineInfo: state => state.mine
}

// actions
const actions = {
  // 用户中心 -- 我的
  clearFav ({ commit }) {
    commit(types.CLEAR_FAV)
  },

  clearMine ({ commit }) {
    commit(types.CLEAR_MINE)
  },

  receiveFav ({ commit, state }, para) {
    ajaxFun({commit, state}, para, state.favFlag, state.favTime, types.RECEIVE_FAV)
  },

  receiveMine ({ commit, state }, para) {
    ajaxFun({commit, state}, para, state.mineFlag, state.mineTime, types.RECEIVE_MINE)
  },

  clearVuex ({ commit, state }) {
    initVuex({commit, state}, types.CLEAR_VUEX)
  }
}

// mutations
const mutations = {
  [types.RECEIVE_FAV] (state, fav) {
    state.fav = fav
    state.favFlag = true
    state.favTime = new Date().getTime()
  },

  [types.RECEIVE_MINE] (state, mine) {
    state.mine = mine
    state.mineFlag = true
    state.mineTime = new Date().getTime()
  },

  [types.CLEAR_FAV] (state) {
    state.favFlag = false
  },

  [types.CLEAR_MINE] (state) {
    state.mineFlag = false
  },

  [types.CLEAR_VUEX] ({commit, state}) {
    initVuex({commit, state})
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/my.js